
export default {
  inject: ['wording'],
}
